// import React, { useState } from 'react';
// import Nav from '../../common/Nav';
// import Footer from '../../common/Footer';

// const AddHotelPage = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     type: '3 ⭐',
//     description: '',
//     rating: '',
//     amenities: '',
//     location: '',
//     contact: '',
//     status: 'Active',
//     images: {
//       hotel: [],
//       lobby: [],
//       reception: [],
//       rooms: [],
//       amenities: [],
//     },
//     video: '',
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleImageChange = (section, files) => {
//     setFormData(prev => ({
//       ...prev,
//       images: {
//         ...prev.images,
//         [section]: Array.from(files),
//       },
//     }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log('Submitting:', formData);
//     // Submit to backend
//   };

//   return (
    
//     <div className="  ">
//       <div>
//         <Nav/>
//       </div>
//       <div className='max-w-5xl mx-auto my-32'>
//       <h1 className="text-2xl font-bold mb-6">Add New Hotel Property</h1>
//       <form onSubmit={handleSubmit} className="space-y-4">
//         <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Hotel Name" className="w-full border p-2 rounded" />

//         <select name="type" value={formData.type} onChange={handleChange} className="w-full border p-2 rounded">
//           <option>3 ⭐</option>
//           <option>4 ⭐</option>
//           <option>5 ⭐</option>
//         </select>

//         <textarea name="description" value={formData.description} onChange={handleChange} placeholder="Hotel Description" className="w-full border p-2 rounded" rows={4} />

//         <input type="text" name="rating" value={formData.rating} onChange={handleChange} placeholder="Google Rating (auto-fetch coming soon)" className="w-full border p-2 rounded" />

//         <input type="text" name="amenities" value={formData.amenities} onChange={handleChange} placeholder="Amenities (comma separated)" className="w-full border p-2 rounded" />

//         <input type="text" name="location" value={formData.location} onChange={handleChange} placeholder="Location" className="w-full border p-2 rounded" />

//         <input type="text" name="contact" value={formData.contact} onChange={handleChange} placeholder="Contact Info" className="w-full border p-2 rounded" />

//         <select name="status" value={formData.status} onChange={handleChange} className="w-full border p-2 rounded">
//           <option>Active</option>
//           <option>Inactive</option>
//         </select>

//         {/* Image Upload Sections */}
//         {['hotel', 'lobby', 'reception', 'rooms', 'amenities'].map(section => (
//           <div key={section}>
//             <label className="block font-semibold capitalize mb-1">{section} Images</label>
//             <input type="file" multiple accept="image/*" onChange={(e) => handleImageChange(section, e.target.files)} className="block w-full" />
//           </div>
//         ))}

//         <input type="text" name="video" value={formData.video} onChange={handleChange} placeholder="Hotel Video Link (YouTube, etc)" className="w-full border p-2 rounded" />

//         <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">Add New Property</button>
//       </form>
//       </div>
//       <Footer/>
//     </div>
//   );
// };

// export default AddHotelPage;

import React, { useState } from 'react';
import {database, db, storage} from '../../auth/firebase';

import {collection, addDoc } from 'firebase/firestore';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import {ref as dbRef,  push, set } from "firebase/database";
// import { initializeApp } from 'firebase/app';

// Firebase config (replace with your actual config)
// const firestoreFirebaseConfig = {
//   apiKey: "AIzaSyBnPt93hSlSHh6cXt6lvpk3JpyrZLP61B0",
//   authDomain: "pravasa-ef1a9.firebaseapp.com",
//   databaseURL: "https://console.firebase.google.com/u/1/project/pravasa-ef1a9/firestore/databases/pravasa01/data/~2Fhotels~2FlMOO054wH82bkHZnhQEt",
//   projectId: "pravasa-ef1a9",
//   storageBucket: "pravasa-ef1a9.firebasestorage.app",
//   messagingSenderId: "950806999863",
//   appId: "1:950806999863:web:5efad48a0280b2e2ed60b2",
//   measurementId: "G-2PHX07RS5M"
// };

// const app = initializeApp(firestoreFirebaseConfig);
// const db = getFirestore(app);
// const storage = getStorage(app);

const AddHotelPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    type: '3 Star',
    description: '',
    rating: '',
    amenities: '',
    location: '',
    contact: '',
    status: 'Active',
    images: {
      hotel: [],
      lobby: [],
      reception: [],
      rooms: [],
      amenities: [],
    },
    video: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (section, files) => {
    setFormData(prev => ({
      ...prev,
      images: {
        ...prev.images,
        [section]: Array.from(files),
      },
    }));
  };

  const uploadImages = async (section, files) => {
    const urls = [];
    for (let file of files) {
      const imageRef = storageRef(storage, `hotels/${section}/${Date.now()}_${file.name}`);
      await uploadBytes(imageRef, file);
      const url = await getDownloadURL(imageRef);
      urls.push(url);
    }
    return urls;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const imageUrls = {};
      for (let section in formData.images) {
        imageUrls[section] = await uploadImages(section, formData.images[section]);
      }

      const hotelData = {
        name: formData.name,
        type: formData.type,
        description: formData.description,
        rating: formData.rating,
        amenities: formData.amenities,
        location: formData.location,
        contact: formData.contact,
        status: formData.status,
        images: imageUrls,
        video: formData.video,
        createdAt: new Date().toISOString(),
      };
      console.log('testing ......')
      const newHotelRef = push(dbRef(database, "hotels"));

    await set(newHotelRef, hotelData);
      // await addDoc(collection(db, "hotels"), hotelData);
      console.log('data:::', hotelData);
      alert("Hotel property added successfully!");
    } catch (error) {
      console.error("Error adding hotel:", error);
      alert("Error submitting hotel data.");
    }
  };

  return (
    <div className="max-w-5xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Add New Hotel Property</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Hotel Name" className="w-full border p-2 rounded" />

        <select name="type" value={formData.type} onChange={handleChange} className="w-full border p-2 rounded">
          <option>3 Star</option>
          <option>4 Star</option>
          <option>5 Star</option>
        </select>

        <textarea name="description" value={formData.description} onChange={handleChange} placeholder="Hotel Description" className="w-full border p-2 rounded" rows={4} />

        <input type="text" name="rating" value={formData.rating} onChange={handleChange} placeholder="Google Rating (auto-fetch coming soon)" className="w-full border p-2 rounded" />

        <input type="text" name="amenities" value={formData.amenities} onChange={handleChange} placeholder="Amenities (comma separated)" className="w-full border p-2 rounded" />

        <input type="text" name="location" value={formData.location} onChange={handleChange} placeholder="Location" className="w-full border p-2 rounded" />

        <input type="text" name="contact" value={formData.contact} onChange={handleChange} placeholder="Contact Info" className="w-full border p-2 rounded" />

        <select name="status" value={formData.status} onChange={handleChange} className="w-full border p-2 rounded">
          <option>Active</option>
          <option>Inactive</option>
        </select>

        {/* Image Upload Sections */}
        {['hotel', 'lobby', 'reception', 'rooms', 'amenities'].map(section => (
          <div key={section}>
            <label className="block font-semibold capitalize mb-1">{section} Images</label>
            <input type="file" multiple accept="image/*" onChange={(e) => handleImageChange(section, e.target.files)} className="block w-full" />
          </div>
        ))}

        <input type="text" name="video" value={formData.video} onChange={handleChange} placeholder="Hotel Video Link (YouTube, etc)" className="w-full border p-2 rounded" />

        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">Add New Property</button>
      </form>
    </div>
  );
};

export default AddHotelPage;
